import { Components } from '@mui/material';

import { Theme } from '../../types';

export const components: Components<Theme> = {
  MuiTypography: {
    styleOverrides: {
      root() {
        return {
          fontFamily: 'inherit !important',
        };
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: () => ({
      body: {
        fontFamily: 'unset',
      },
    }),
  },
  MuiLink: {
    styleOverrides: {
      root({ theme }) {
        return {
          color: theme.palette.blue[700],
          textDecoration: 'none',
        };
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root({ theme }) {
        return {
          textTransform: 'none',
          color: theme.palette.textWhite,
          fontFamily: 'inherit',

          '&:hover': {
            color: theme.palette.blue[900],
            backgroundColor: 'transparent',
          },
        };
      },
      contained({ theme }) {
        return {
          background: `linear-gradient(180deg, ${theme.palette.stateNormal[0]} 0%, #1450C8 100%)`,
          color: theme.palette.textWhite,
          border: 'none',

          '&.MuiButton-contained': {
            '&:hover': {
              background: 'linear-gradient(180deg, #2354FE 0%, #103AB9 100%)',
              color: theme.palette.textWhite,
            },
          },

          '&:disabled': {
            color: theme.palette.textWhite,
            backgroundColor: theme.palette.stateDisabled,
            border: 'none',
          },
        };
      },
      outlined({ theme }) {
        return {
          backgroundColor: 'transparent',
          color: theme.palette.textWhite,
          border: `1px solid ${theme.palette.stateNormal[0]}`,

          '&:hover': {
            backgroundColor: 'transparent',
            color: theme.palette.stateHover,
            border: `1px solid ${theme.palette.stateHover}`,
          },

          '&:disabled': {
            color: theme.palette.textWhite,
            backgroundColor: theme.palette.stateDisabled,
            border: 'none',
          },
        };
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root({ theme }) {
        return {
          textTransform: 'none',
          minHeight: '48px',
          color: theme.palette.text2,
          '&:hover': {
            background:
              'linear-gradient(180deg, rgba(49, 121, 255, 0.00) 0%, rgba(49, 121, 255, 0.10) 100%)',
          },
          '&.Mui-selected': {
            background:
              'linear-gradient(180deg, rgba(49, 121, 255, 0.00) 0%, rgba(49, 121, 255, 0.10) 100%)',
          },
        };
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root() {
        return {
          height: '56px !important',
        };
      },
      input() {
        return {
          fontSize: '14px !important',
        };
      },
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root() {
        return {
          background: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
        };
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      content({ theme }) {
        return {
          margin: theme.spacing(6, 0),
        };
      },
      expandIconWrapper({ theme }) {
        return {
          backgroundColor: theme.palette.grey?.[900],
          borderRadius: `${theme.shape.borderRadius * 4}px`,
          border: `1px solid ${theme.palette.grey?.[700]}`,
          width: theme.spacing(8),
          minWidth: theme.spacing(8),
          height: theme.spacing(8),
          marginLeft: theme.spacing(2),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        };
      },
    },
  },
};
